<app-cancel-open-banking-popin (continue)="closePopin()" [show]="isPopinOpen"></app-cancel-open-banking-popin>

<div class="flex flex-col flex-1 h-full justify-between">
  <div>
    @for (account of selectedAccounts(); track account; let i = $index) {
      <label class="flex flex-col border-2 rounded-xl p-4 mb-2 border-gray-200">
        <div class="flex flex-row justify-between">
          <div class="flex flex-row">
            <div class="place-self-center mr-4">
              @if (!isTestBankConnector()) {
                <img [src]="selectedBank().logo" class="w-6 h-6" alt="selected bank logo" />
              }
              @if (isTestBankConnector()) {
                <img
                  src="../../../../../assets/images/test_bank_connector.png"
                  class="w-6 h-6"
                  alt="test bank logo"
                />
              }
            </div>
            <div>
              @if (account.type === 'CHECKING' || account.type === 'CARD') {
                <p class="text-xs self-end">{{ 'deposit_account' | translate }}</p>
              }

              @if (account.number !== null) {
                <p>
                  <span data-cs-mask>{{ account.number.slice(0, -4) }}</span
                  >{{ account.number.slice(-4) }}
                </p>
              }
            </div>
          </div>

          <span>
            {{
              account.balance
                | currency: account.currency ?? ('currency_not_found' | translate) : 'symbol' : '1.2-2' : 'fr'
            }}</span
          >
        </div>
      </label>
    }
  </div>

  @if (!isAccountAnalysisDone) {
    <div class="flex flex-col m-auto">
      <img class="m-auto" src="../../../../../assets/svg/loader.svg" alt="loader" />
      <div class="flex flex-1 place-items-center justify-center mt-5">{{ waitingMessage }}</div>
    </div>
  } @else {
    @if (accountAnalysisState === 'SUCCESS') {
      <div class="self-center">
        <img class="mb-5 w-8 h-8 mx-auto" src="../../../../../assets/images/svg/check-circle.svg" />
        <p class="text-center">{{ 'connection_to_accounts_successfull' | translate }}</p>
      </div>
      <div>
        <app-auto-closed-button
          class="w-full"
          [closeCallback]="continueSuccess"
          [delayInSeconds]="5"
          [text]="'continue' | translate"
        ></app-auto-closed-button>
        <div class="bg-informationBg flex p-4 mb-7 mt-7">
          <img
            class="w-5 h-5 mr-4 place-self-center"
            src="../../../../../assets/images/svg/information.svg"
          />
          <p
            class="text-sm text-secondary"
            [innerHTML]="'income_are_determined_thanks_to_aggregated_account_warning' | translate"
          ></p>
        </div>
      </div>
    }
    @if (accountAnalysisState === 'RETRY_ACCOUNT') {
      <div class="flex flex-1 flex-col place-items-center justify-center">
        <img class="mb-5" src="../../../../../assets/images/svg/cross-error.svg" />
        <p class="font-bold text-center">{{ 'data_retrieval_has_failed' | translate }}</p>
      </div>
      <div>
        <button
          (click)="retryAccountAnalysis()"
          class="bg-primary font-bold text-secondary m-auto flex-1 pt-3 pb-3 rounded-full mb-6 w-full"
        >
          {{ 'retry_connection' | translate }}
        </button>
        <button
          (click)="openPopin()"
          class="bg-gray-100 font-bold text-secondary m-auto flex-1 pt-3 pb-3 rounded-full mb-6 w-full text-sm"
        >
          {{ 'come_back_to_classic_form' | translate }}
        </button>
      </div>
    }
    @if (accountAnalysisState === 'INSUFFICIENT_INCOME') {
      <div class="flex flex-1 flex-col place-items-center justify-center">
        <img class="mb-5" src="../../../../../assets/images/svg/cross-error.svg" />
        <p class="font-bold text-center">{{ 'insufficient_income' | translate }}</p>
      </div>
      <div>
        <button
          (click)="retryAccountAnalysis()"
          class="bg-primary font-bold text-secondary m-auto flex-1 pt-3 pb-3 rounded-full mb-6 w-full"
        >
          {{ 'retry_connection' | translate }}
        </button>
        <button
          (click)="openPopin()"
          class="bg-gray-100 font-bold text-secondary m-auto flex-1 pt-3 pb-3 rounded-full mb-6 w-full text-sm"
        >
          {{ 'come_back_to_classic_form' | translate }}
        </button>
      </div>
    }
    @if (accountAnalysisState === 'FAILED') {
      <div class="self-center">
        <img class="mb-5 w-8 h-8 mx-auto" src="../../../../../assets/images/svg/cross-error.svg" />
        <p class="font-bold mb-5 text-center">{{ 'data_retrieval_has_failed' | translate }}</p>
        <p class="text-center">
          {{ 'data_retrieval_has_failed_will_be_redirected_to_classic_form' | translate }}
        </p>
      </div>
      <app-auto-closed-button
        class="w-full mb-7"
        [closeCallback]="continueFailure"
        [delayInSeconds]="5"
        [text]="'continue' | translate"
      ></app-auto-closed-button>
    }
  }
</div>
